import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import { router, i18n } from '@/helpers'
import store from './store'

import _ from "lodash";
import * as Directive from "@/defs/directive.js";
import "@/assets/style/global.less";

Vue.config.productionTip = false
Vue.use(_);
Vue.prototype.$axios = axios
Vue.directive('closable-div', Directive.ClosableDiv)

new Vue({
  render: h => h(App),
  router,
  i18n,
  store
}).$mount('#app')
